import axios from './axios_config';
import { baseURL } from '../helper/apiPathConfig';

// const MAX_REQUESTS_COUNT = 3;
// const INTERVAL_MS = 10;
// let PENDING_REQUESTS = 0;

/**
 * Axios Request Interceptor
 */
// axios.interceptors.request.use(function (config) {
//   return new Promise((resolve) => {
//     let interval = setInterval(() => {
//       if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
//         PENDING_REQUESTS++;
//         clearInterval(interval);
//         resolve(config);
//       }
//     }, INTERVAL_MS);
//   });
// });

/**
 * Axios Response Interceptor
 */
// axios.interceptors.response.use(
//   function (response) {
//     PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
//     return Promise.resolve(response);
//   },
//   function (error) {
//     PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
//     return Promise.reject(error);
//   }
// );

const post = (url, payload) => {
  return axios.post(`${baseURL}${url}`, payload);
};

const get = (url) => {
  return axios.get(`${baseURL}${url}`);
};

export const authen_api = {
  login: (payload) => post('/ldap-login', payload),
  logout: (payload) => post('/ldap-logout', payload),
  get_user_role: () => get('/get-user-role')
};
